import React, { useState, useEffect } from "react";
import "./financebox.scss";
import { Budget, BudgetType, Funding, FundingId } from "../../Objects/Project";
import { convertToCurrencyLabel } from "../Helpers";

interface FinanceBoxProps {
  title: string;
  project: any;
}

// TODO: Regroup the funding name, so that it is split in to business unit, knowledge group and funding channel
// TODO: Order the funding and budget parts by the funding name and fiscal year (descending)
// TODO: group related fundings

const FinanceBox = ({ title, project }: FinanceBoxProps) => {
  const [fundings, setFundings] = useState<{ [key: string]: Funding[] }>();
  const [budgets, setBudgets] = useState<Budget[]>([]);
  // group fundings filter(x => !x.isGlobal).filter(x => x.researchGroupId === funding.researchGroupId && x.fundingChannel === funding.fundingChannel
  useEffect(() => {
    if (!project) return;
    else {
      const unbudgettedBudgets = project?.fundings?.models.map(
        (funding: Funding) =>
          createUnbudgetted(funding, project?.budgets?.models)
      );
      const newFundings = [...project?.fundings?.models];
      const newBudgets = [...project?.budgets?.models, ...unbudgettedBudgets];
      const mappedFundings = mapFundings(newFundings);
      setBudgets(newBudgets);
      setFundings(mappedFundings);
    }
  }, []);

  function RenderTotalFundingAndBudget(
    fundings: { [key: string]: Funding[] } | undefined,
    budgets: Budget[]
  ): React.ReactNode {
    const totalfunding = createTotalFunding(fundings);
    const totalbudgets = createTotalBudget(budgets, totalfunding);
    return (
      <div className="row bottomborderFat">
        <div className="panel funding">
          <FundingPart funding={totalfunding} />
        </div>
        <div className="panel budget bottomborderFat">
          {totalbudgets
            .filter(
              (budget) =>
                budget.funding && budget.funding.id === totalfunding.id
            )
            .map((budget) => {
              return (
                <div key={budget.id} className={`row bottomBorder`}>
                  <BudgetPart budget={budget} />
                </div>
              );
            })}
        </div>
      </div>
    );
  }

  return (
    <div className="box">
      <div className="fGrid">
        <Headers />
        {/* Totaal */}
        {RenderTotalFundingAndBudget(fundings, budgets)}
        {fundings &&
          Object.keys(fundings).map((key) =>

            fundings[key].map((funding: any, index) => (
              <div
                key={funding.id}
                className={`row  ${
                  funding.isTotal ? "bottomborderFat" : ""
                }  ${
                  index === fundings[key].length - 1 ? "bottomborder" : ""
                }`}>
                <div className="panel funding">
                  <FundingPart funding={funding} />
                </div>
                <div
                  className={`panel budget  ${
                    funding.isTotal ? "bottomborderFat" : ""
                  }`}
                >
                  {budgets
                    .filter(
                      (budget) =>
                        budget.funding && budget.funding.id === funding.id
                    )
                    .map((budget) => {
                      return (
                        <div key={budget.id} className={`row bottomBorder`}>
                          <BudgetPart budget={budget} />
                        </div>
                      );
                    })}
                </div>
              </div>
            ))
            
          )}
      </div>
    </div>
  );
};

function FundingPart({ funding }: { funding: Funding }) {
  // Split the name of the funding in to business unit, knowledge group and funding channel
  const [businessUnit, setBusinessUnit] = useState<string>("");
  const [knowledgeGroup, setKnowledgeGroup] = useState<string>("");
  const [fundingChannel, setFundingChannel] = useState<string>("");

  useEffect(() => {
    setBusinessUnit(funding?.businessUnitId?.name || "");
    setKnowledgeGroup(funding?.knowledgeGroupId?.name || "");
    setFundingChannel(funding?.fundingChannelId?.name || "");
  }, [funding]);
  funding.isGlobal = funding.type === "Globaal" ? true : false;
  return (
    <>
      <div className="item AllowWrap small">
        {funding.isGlobal && <span className="subtotal">Globaal</span>}
        {funding.isTotal && <span className="subtotal">Totaal</span>}
        {businessUnit}
        <br />
        {knowledgeGroup}
        <br />
        {fundingChannel}
        <br />        
      </div>
      <div className="item money">{funding.fiscalYear?.name}</div>
    </>
  );
}

function BudgetPart({ budget }: { budget: Budget}) {

  const [danger, setDanger] = useState<string>("");
  useEffect(() => {

    if (budget.isUnbudgeted) {
      if(budget.amount < 0) {
        setDanger(" danger");
      }
    } else {
      setDanger("");
    }
  }, []);

  return (
    <>
      {(budget && !budget.isTotal && (
        <div className=" item small type">{budget.type && budget?.type?.name}</div>
      )) }
      {
        (budget && budget.isTotal && (
          <div className=" item small  total">{budget.name}</div>
        ))}
        
      <div className={"money item " + danger}>{convertToCurrencyLabel(budget?.amount)}</div>

      <div className="money item">{convertToCurrencyLabel(budget?.booked)}</div>

      <div className="money item">
        {convertToCurrencyLabel(budget?.reserved)}
      </div>

      <div className="money item">
        {convertToCurrencyLabel(budget?.available)}
      </div>
    </>
  );
}

function Headers() {
  return (
    <div className="header container">
      <div className="row header">
        <div className="panel funding header">
          <div className="item removeborderleft" />
          <div className="item removeborderleft" />
        </div>

        <div className="panel budget header">
          <div className="row">
            <div className="item bigborderleft" />
            <div className="item removeborderleft" />
            <div className="item subtotal removeborderleft">Uitgaven</div>
            <div className="item removeborderleft" />
            <div className="item removeborderleft" />
          </div>
        </div>
      </div>

      <div className="row header">
        <div className="panel funding">
          <div className="item minheight removeborderleft">
            Business Unit
            <br />
            Knowledge Group
            <br />
            Funding Channel
          </div>
          <div className="item minheight money">Boekjaar</div>
        </div>

        <div className="panel budget">
          <div className="row">
            <div className="item minheight bigborderleft">Type</div>
            <div className="item minheight money">Gebudgeteerd</div>
            <div className="item minheight money">Geboekt</div>
            <div className="item minheight money">Gereserveerd</div>
            <div className="item minheight money">Beschikbaar</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinanceBox;

function createTotalFunding(fundings: {[key: string]: Funding[]} | undefined): any {
  // create total funding
  const totalFunding: Funding = {
    id: "1",
    name: "Totaal",
    amount: 0,
    projectId: null,
    modelType: "",
    contact: null,
    currency: null,
    fundingChannelId: null,
    detailedFundingChannelId: null,
    businessUnitId: null,
    project: null,
    description: null,
    isActive: false,
    reference: null,
    receivedFrom: null,
    type: "",
    isTotal: true,
    isGlobal: null,
    knowledgeGroupId: null,
    fiscalYear: undefined,
    declaration: 0
  };
  for (const key in  fundings) {
    console.log(key);
    fundings[key].forEach((funding) => {
      totalFunding.amount += funding.amount;
      totalFunding.declaration += funding.declaration;
    });
  }
  return totalFunding;
}

function createTotalBudget(budgets: Budget[], linktoFunding: Funding): Budget[] {
  // create total budget

  const funding: FundingId = {
    id: linktoFunding?.id || "",
    name: linktoFunding?.name || "",
    modelType: linktoFunding?.modelType || "",
  };

  const totalBudget: Budget = {
    id: "0",
    name: "Totaal",
    amount: 0,
    modelType: "",
    description: null,
    isActive: false,
    reference: null,
    type: null,
    isTotal: true,
    isGlobal: undefined,
    funding: funding,
    project: null,
    idea: null,
    booked: 0,
    reserved: 0,
    available: 0,
    paidTo: null,
    isUnbudgeted: false,
  };
  // create seperate total budgets for each type then add a total type
  const totalBudgets: Budget[] = [];
  totalBudgets.push(totalBudget);

  budgets.forEach((budget) => {
    const type = budget.type;
    // Zoek het totale budget voor dit type in totalBudgets
    const totalBudgetForType = totalBudgets.find((totalBudget) => totalBudget.type?.name === type?.name);
  
    if (totalBudgetForType) {
      // Als het totale budget al bestaat, voeg het bedrag toe
      totalBudgetForType.amount += budget.amount;
      totalBudgetForType.booked += budget.booked;
      totalBudgetForType.reserved += budget.reserved;
      totalBudgetForType.available += budget.available;
    } else {
      // Als het totale budget niet bestaat, voeg een nieuw object toe
      const totalBudgetType: Budget = {
        id: "0",
        name: type?.name ? type.name : "Totaal",
        amount: budget.amount,
        modelType: "",
        description: null,
        isActive: false,
        reference: null,
        type: type,
        isTotal: true,
        isGlobal: undefined,
        funding: funding,
        project: null,
        idea: null,
        booked: budget.booked,
        reserved: budget.reserved,
        available: budget.available,
        paidTo: null,
        isUnbudgeted: true,
      };
      totalBudgets.push(totalBudgetType);
    }
  });
  // each budget has a type, we need to create a total budget for each type

  budgets.forEach((budget) => {
    totalBudget.amount += budget.amount;
    totalBudget.booked += budget.booked;
    totalBudget.reserved += budget.reserved;
    totalBudget.available += budget.available;
  });

  // create total for each type that exists in budgets

  return totalBudgets;
}

function createUnbudgetted(funding: Funding, budgets: Budget[], isTotal?: boolean) {

  /**
   * create a budget for the unbudgetted amount
   * to calc the unbudgetted amount, we need to know the total amount of the funding
   * and the total amount of the budget
   * the unbudgetted amount is the difference between the two
   */
  const fundingId: FundingId = {
    id: funding?.id || "",
    name: funding?.name || "",
    modelType: funding?.modelType || "",
  };
  let totalAmount = 0;

  // find every budget that is linked to this funding and add the amount to the totalAmount
  budgets.forEach((budget) => {
    if (budget.funding?.id === fundingId.id) {
      totalAmount += budget.amount;
    }
  }
  );
  

      const result = funding.amount - totalAmount;
      const type: BudgetType = {
        id: "0",
        name: "Niet gebudgetteerd",
        modelType: "",
      };
      const unbudgetted: Budget = {
        modelType: "",
        id: "0",
        name: "Niet gebudgetteerd",
        description: null,
        funding: fundingId,
        project: null,
        idea: null,
        amount:  result,
        booked: 0,
        reserved: 0,
        available: 0,
        type: type,
        isActive: false,
        reference: null,
        paidTo: null,
        isTotal: false,
        isGlobal: false,
        isUnbudgeted: true,
      };
      return unbudgetted;
}


  // group fundings filter(x => !x.isGlobal).filter(x => x.researchGroupId === funding.researchGroupId && x.fundingChannel === funding.fundingChannel  
  // return dictonary
  // make object with key = business unit + knowledge group + funding channel and value = array of fundings
  // loop through fundings
  // check if the key exists in the dictonary
  // if it does, add the funding to the array
  // if it does not, create the key and add the funding to the array

  function mapFundings(fundings: Funding[]): { [key: string]: Funding[] } {

    const dict: { [key: string]: Funding[] } = {};
    fundings.forEach((funding) => {
      if (!funding.isGlobal && funding.businessUnitId && funding.fundingChannelId){
      const key = funding.businessUnitId?.id + funding.fundingChannelId?.id;

      if (key in dict) {
        dict[key].push(funding);
      } else {
        dict[key] = [funding];
      }
    }
    else {
      if("global" in dict)
      {
        dict["global"].push(funding);
      }
      else {
        dict["global"] = [funding];
      }
    }
    });
    return dict;
  }
